import { Game } from "@blacknut/javascript-sdk/dist";
import { useCallback } from "react";
import { useHistory } from "react-router";

const useGameAuthorizationFlow = (game?: Game) => {
  const history = useHistory();
  const authorize = useCallback(async () => {
    if (game && game.addonOption?.isUbisoftProduct) {
      history.replace(`/game/${game.id}/authorize/ubisoft`);
      return Promise.resolve(false);
    }
    return Promise.resolve(true);
  }, [game, history]);
  return { authorize };
};
export { useGameAuthorizationFlow };
